(function ($) {
  var scriptObj = localizedData.userCommentsScript;

  $(document).ready(function () {
    function userCommentTriggerInitialClick(targetPcId, targetRowIndex) {
      setTimeout(function () {
        // Find the first .gallery-photo-comment element that meets the criteria and is not within a .slick-cloned element
        var $originalElements = $('.user-comment-item').filter(function () {
          var pc_id = $(this).attr('data-pc-id');
          var data_row_index = $(this).attr('data-upload-photo-index');

          localStorage.removeItem('userCommentTriggerInitialClickPc');
          localStorage.removeItem('userCommentTriggerInitialClickRow');
          return pc_id === targetPcId && data_row_index === targetRowIndex;
        });

        if ($originalElements.length > 0) {
          // Trigger click on the first original element that meets the criteria
          $originalElements.first().trigger('click');
        }
      }, 1000); // Adjust the delay (in milliseconds) as needed
    }

    if (localStorage.getItem('userCommentTriggerInitialClick') === 'true') {
      var pc_id = localStorage.getItem('userCommentTriggerInitialClickPc');
      var row_index = localStorage.getItem('userCommentTriggerInitialClickRow');
      localStorage.removeItem('userCommentTriggerInitialClick');
      userCommentTriggerInitialClick(pc_id, row_index);
    }
  });

  // For opening the popup of the photo with its comment.
  $(document).on('click', '.user-comment-item', function (e) {
    e.preventDefault();
    var pc_id = $(this).attr('data-pc-id');
    var photo_index = $(this).attr('data-upload-photo-index');
    $.ajax({
      url: scriptObj.ajax_url,
      method: 'POST',
      dataType: 'json',
      data: {
        pc_id: pc_id,
        action: 'akd_user_comments',
        nonce: scriptObj.user_comments_nonce,
        photo_index: photo_index,
      },
      success: function (response) {
        let htmlresponse = response.data.html;
        if (htmlresponse) {
          $('main').append(htmlresponse);
          // Check if there are more blogs.
        }
      },
    });
  });

  // Loading after the ajax complete.
  $(document).on('ajaxComplete', function () {
    $('#user-add-photo-comment-form').validate({
      rules: {
        comment: {
          required: true,
          maxlength: 250,
        },
      },
      messages: {
        comment: {
          required: 'Cannot be empty.',
          maxlength: 'Comment cannot be more than 250 characters.',
        },
      },
      submitHandler: function (form) {
        var formData = new FormData(form);
        formData.append('action', 'user_insert_photo_comment');
        formData.append('nonce', scriptObj.insert_photo_comment_nonce);
        $.ajax({
          url: scriptObj.ajax_url,
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          success: function (response) {
            var species_id = response.data.species_id;
            var pc_id = response.data.pc_id;
            var data_row_index = response.data.data_row_index;
            localStorage.setItem('userCommentTriggerInitialClick', 'true');
            localStorage.setItem('userCommentTriggerInitialClickPc', pc_id);
            localStorage.setItem(
              'userCommentTriggerInitialClickRow',
              data_row_index
            );
            // Reload the page
            location.reload();
            // window.location.replace(window.location.href);
          },
          error: function (xhr, status, error) {},
        });
      },
    });

    $('#user-edit-photo-comment-form').validate({
      rules: {
        comment: {
          required: true,
          maxlength: 250,
        },
      },
      messages: {
        comment: {
          required: 'Cannot be empty.',
          maxlength: 'Comment cannot be more than 250 characters.',
        },
      },
      submitHandler: function (form) {
        var formData = new FormData(form);
        formData.append('action', 'user_insert_photo_comment');
        formData.append('nonce', scriptObj.insert_photo_comment_nonce);
        $.ajax({
          url: scriptObj.ajax_url,
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          success: function (response) {
            var pc_id = response.data.pc_id;
            var data_row_index = response.data.data_row_index;
            localStorage.setItem('userCommentTriggerInitialClick', 'true');
            localStorage.setItem('userCommentTriggerInitialClickPc', pc_id);
            localStorage.setItem(
              'userCommentTriggerInitialClickRow',
              data_row_index
            );
            // Reload the page
            location.reload();
          },
          error: function (xhr, status, error) {},
        });
      },
    });
  });

  // For showing edit comment in the photo.
  $(document).on('click', '.user_edit_photo_comment', function () {
    // Get the nearest parent element with the class .each-comment
    var eachComment = $(this).closest('.each-comment');
    var commentText = eachComment
      .find('.comment-bottom .comment')
      .text()
      .trim();

    // Now you have the eachComment element, you can perform any action you need
    var pc_id = eachComment.data('pc-id');
    var row_index = eachComment.data('row-index');
    var comment_index = eachComment.data('comment-index');

    var comment_edit_popup = $(this)
      .closest('.comment-message-popup-wrapper')
      .find('#user-comment-edit-popup');
    var pc_id = eachComment.data('pc-id');
    var row_index = eachComment.data('row-index');
    var comment_index = eachComment.data('comment-index');

    comment_edit_popup.show();
    comment_edit_popup.find('input[name="comment"]').val(commentText);
    comment_edit_popup.find('input[name="pc_id"]').val(pc_id);
    comment_edit_popup.find('input[name="data_row_index"]').val(row_index);
    comment_edit_popup.find('input[name="comment_index"]').val(comment_index);
    // You can also perform other actions, such as opening an edit form, etc.
  });

  // For showing deleting comment in the photo.
  $(document).on('click', '.user_delete_photo_comment', function () {
    // Get the nearest parent element with the class .each-comment
    var eachComment = $(this).closest('.each-comment');

    // Now you have the eachComment element, you can perform any action you need
    var pc_id = eachComment.data('pc-id');
    var row_index = eachComment.data('row-index');
    var comment_index = eachComment.data('comment-index');
    var confirmMssg = 'Do you really want to delete?';
    if (confirm(confirmMssg) == true) {
      $.ajax({
        url: scriptObj.ajax_url,
        type: 'POST',

        data: {
          action: 'user_delete_photo_comment_popup',
          pc_id: pc_id,
          row_index: row_index,
          comment_index: comment_index,
          nonce: scriptObj.delete_photo_comment_popup_nonce,
        },
        success: function (response) {
          if (response.data.species_id) {
            var species_id = response.data.species_id;
            localStorage.setItem('userCommentTriggerInitialClick', 'true');
            localStorage.setItem('userCommentTriggerInitialClickPc', pc_id);
            localStorage.setItem(
              'userCommentTriggerInitialClickRow',
              row_index
            );
            // Reload the page
            location.reload();
          }
        },
        error: function (xhr, status, error) {},
      });
    }
  });

  // For closing comment pop-up.
  $(document).on('click', '.comment-message-pop-up-close', function () {
    // Get the nearest parent element with the class .each-comment
    $(this).closest('.npx-popup-wrapper').remove();
    // $(this).closest('.comment-message-popup-main').remove();
  });

  // For closing comment edit pop-up.
  $(document).on('click', '#user_cancel_edit_image_comment', function () {
    // Get the nearest parent element with the class .each-comment
    $(this).closest('#user-comment-edit-popup').hide();
    $(this).closest('#user-comment-edit-popup').reset();
  });
})(jQuery);
